import React from 'react'

import { IActivity } from '../../../Activity/interface/IActivity'
import { useAppDispatch } from '../../../App/Hooks/reduxHooks'
import { updateKnowledgeList } from '../Store/Actions'
import { PersonKnowledge } from '../util/PersonKnowledge'

import { CheckboxInput, Input, TableData, TableRowBody } from './style'

type Props = {
  knowledgeData: PersonKnowledge[]
  activityList: IActivity[]
  windowWidth: number
}

export const KnowledgeTableBody: React.FC<Props> = ({
  knowledgeData,
  windowWidth,
  activityList,
}) => {
  const dispatch = useAppDispatch()

  const onCheckboxChange = (row: PersonKnowledge) => {
    const newKnowledgeData = knowledgeData.map(knowledge => {
      if (knowledge.uuid === row.uuid) {
        return {
          ...knowledge,
          isActive: !knowledge.isActive,
        }
      }
      return knowledge
    })
    dispatch(updateKnowledgeList(newKnowledgeData))
  }

  const onInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    row: PersonKnowledge,
  ) => {
    const newDuration = Number(event.target.value)

    const newKnowledgeData = knowledgeData.map(knowledge => {
      if (knowledge.uuid === row.uuid) {
        return {
          ...knowledge,
          customDuration: newDuration,
        }
      }
      return knowledge
    })

    dispatch(updateKnowledgeList(newKnowledgeData))
  }

  return (
    <>
      {knowledgeData.map(row => {
        const activityData = activityList.find(
          activity => activity.uuid === row.name,
        ) as IActivity
        return (
          <TableRowBody key={row.uuid}>
            <TableData width={windowWidth}>
              <CheckboxInput
                type="checkbox"
                checked={row.isActive}
                width={windowWidth}
                onChange={() => {
                  onCheckboxChange(row)
                }}
              />
            </TableData>
            <TableData width={windowWidth}>
              {activityData?.name || row.name}
            </TableData>
            <TableData width={windowWidth}>
              <Input
                value={
                  row.customDuration > 0
                    ? row.customDuration
                    : activityData.duration
                }
                type="number"
                onChange={e => onInputChange(e, row)}
              />
            </TableData>
            <TableData width={windowWidth}>{activityData.duration}</TableData>
          </TableRowBody>
        )
      })}
    </>
  )
}
